import React from "react";
import * as R from "ramda";
import { Progress } from "antd";
import styled from "styled-components/macro";

const Percentage = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SocialStyleWrapper = styled.div`
  p.khorInt_Titulo1 {
    font-weight: bold;
    border-bottom: 1px solid #d9d9d9;
    padding-bottom: 0.5em;
    margin-bottom: 0.5em;
  }
`;

const SocialStyleType = styled.div`
  h3 {
    margin-bottom: 1em;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #d9d9d9;
    padding-bottom: 20px;
  }
  &:not(:first-child) {
    padding-top: 20px;
  }
`;

const testTypes = [
  { type: "daily", descriptionType: "cotidiana", resultKeyLetter: "C" },
  { type: "motivating", descriptionType: "motivante", resultKeyLetter: "M" },
  {
    type: "underPressure",
    descriptionType: "Bajo Presion",
    resultKeyLetter: "P"
  }
];

export default function SocialStyle({
  t,
  serviceCallRequest: {
    resultados: percentageResults,
    interpretacion: descriptions
  }
}) {
  const resultsByType = testTypes.map(testType => ({
    title: t(`opportunity:process.candidateDetails.tests.${testType.type}`),
    descriptionHTML: R.pipe(
      R.find(R.propEq("tipo", testType.descriptionType)),
      R.propOr("", "texto")
    )(descriptions),
    results: percentageResults.filter(
      ({ factor }) => factor[1] === testType.resultKeyLetter
    )
  }));

  return (
    <SocialStyleWrapper>
      {resultsByType.map(({ title, descriptionHTML, results }) => (
        <SocialStyleType key={title}>
          <h3>{title}</h3>
          <div
            dangerouslySetInnerHTML={{
              __html: descriptionHTML.replace(/[A-Z]\/[A-Z] /g, "")
            }}
          />
          {results.map(({ factor, nombrefactor, resultado }) => (
            <Percentage key={factor}>
              <span data-test={`english-test-${factor}`}>
                {nombrefactor} ({resultado}%)
              </span>
              <Progress
                percent={resultado > 1 ? resultado : 1}
                showInfo={false}
                strokeColor={R.cond([
                  [R.gte(40), R.always("#F5242E")],
                  [R.gte(60), R.always("#e0b500")],
                  [R.gte(100), R.always("#53C819")]
                ])(resultado)}
              />
            </Percentage>
          ))}
        </SocialStyleType>
      ))}
    </SocialStyleWrapper>
  );
}
